<script setup lang="ts">
import { useSeoHead } from '~/composables/useSeoHead'

definePageMeta({
  hideDefaultTopNav: true,
  newsCategory: 'bit_yaowen',
})

const { t } = useAppI18n()

useSeoHead({
  title: () => t('85602'),
  description: () => t('85600'),
  keywords: () => t('85602').replace(/\s*\|\s*WikiBit\s*$/i, ''),
})
</script>

<template>
  <NewsListContent />
</template>
